import Amenity from ".";

export default class CollectionAmenity extends Amenity {

    icon = null;

    constructor(data) {
        super(data)

        this.icon = data?.icon ?? this.icon;
        this.type = 'standard';
    }

    get groups() {
        return [];
    }

    get types() {
        switch(this.group) {
            case 'standard' :
                return []
            case 'open' :
                return []
        } 
    }
}